import React from 'react';

import NotFound from '@components/NotFound';

import AdminManagement from '@views/Admin/Management';

function AdminPage() {
  return (
    <AdminManagement.Layout title="Admin">
      <NotFound />
    </AdminManagement.Layout>
  );
}

export default AdminPage;
